import { type FC } from 'react';
import { Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import { type PayoutTrader } from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';

interface TraderProfileCardProps {
    fallbackTraderId: string;
    trader?: PayoutTrader;
}

export const TraderProfileCard: FC<TraderProfileCardProps> = ({ fallbackTraderId, trader }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap='sm'>
                <Text
                    fw={600}
                    size='sm'
                >
                    Профиль
                </Text>

                <SimpleGrid
                    cols={{ base: 1, xs: 2, md: 1 }}
                    spacing='xs'
                >
                    <KeyValuePair
                        label='ID'
                        value={trader?.id?.value ?? fallbackTraderId}
                        isCopyEnabled
                    />
                    <KeyValuePair
                        label='UserID'
                        value={trader?.userId?.value}
                        isCopyEnabled
                    />

                    <KeyValuePair
                        label='Имя пользователя'
                        value={trader?.username}
                        isCopyEnabled
                    />

                    {trader?.traderName?.value && (
                        <KeyValuePair
                            label='Имя трейдера'
                            value={trader.traderName.value}
                            isCopyEnabled
                        />
                    )}

                    <KeyValuePair
                        label='Email для чеков'
                        value={trader?.checkEmail?.value}
                        isCopyEnabled
                    />
                    <KeyValuePair
                        label='ID аккаунта банка'
                        value={trader?.bankAccountId}
                        isCopyEnabled
                    />
                    <KeyValuePair
                        label='Control ID'
                        value={trader?.controlId}
                        isCopyEnabled
                    />
                </SimpleGrid>
            </Stack>
        </Paper>
    );
};
